export default {"src":"/_next/static/media/replit.a5009458.svg","height":2531,"width":2531,"blurWidth":0,"blurHeight":0};